export const HEADER_MODAL = {
  BRIDGE: 'bridge',

  WRAPPEDASSETS: 'migrate',
  SETTINGS: 'settings',
};
